import { Currency } from '@/core/currency/interfaces';

const SYP: Currency = {
    name: 'Syrian Pound',
    demonym: 'Syrian',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '760',
    symbol: 'LS',
    symbolNative: 'ل.س.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SYP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SYP;
